import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 16 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.75 2.5C12.2018 2.5 15 5.29822 15 8.75C15 10.1754 14.5228 11.4894 13.7194 12.5409L17.2559 16.0774C17.5814 16.4028 17.5814 16.9305 17.2559 17.2559C16.9305 17.5814 16.4028 17.5814 16.0774 17.2559L12.5409 13.7194C11.4894 14.5228 10.1754 15 8.75 15C5.29822 15 2.5 12.2018 2.5 8.75C2.5 5.29822 5.29822 2.5 8.75 2.5ZM13.3333 8.75C13.3333 6.21869 11.2813 4.16667 8.75 4.16667C6.21869 4.16667 4.16667 6.21869 4.16667 8.75C4.16667 11.2813 6.21869 13.3333 8.75 13.3333C11.2813 13.3333 13.3333 11.2813 13.3333 8.75Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}